import React, { Fragment } from 'react'
import GatsbyImage from 'gatsby-image'
import { StaticQuery, graphql } from 'gatsby'
import styled from '@emotion/styled'
import ThemeConsumer from '@/hoc/ThemeConsumer'
import { layouts } from '@/utils/preset'
import { tablet, mobile } from '@/utils/media'
import { mq, rem } from '@/utils/helpers'
import SectionHead from '@/components/app/SectionHead'

const Template = props => {
  const { ...others } = props
  return (
    <StaticQuery
      query={query}
      render={data => {
        return (
          <Root {...others}>
            <Container>
              <Head
                sub="WORKS"
                main={(
                  <Fragment>制作<strong>実績</strong></Fragment>
                )}
                lead={(
                  <Head_Lead>購買に直結する洗練されたデザイン、<br />写真・動画撮影やライティングもお任せください</Head_Lead>
                )}
                body={(
                  <Fragment>自社ECの運営を通じて蓄積したWEBマーケティングの知見と、各分野のプロフェッショナルが連携した強力なクリエイティブは、依頼主様から高い評価をいただいています。商品・イメージビジュアルの撮影やコピーライティングをはじめ、動画や3Dアニメーションといったリッチコンテンツも制作可能です。</Fragment>
                )}
              />
              <Image fluid={data.image.childImageSharp.fluid} alt="Shopify ECサイト構築 実績" />
            </Container>
          </Root>
        )
      }}
    />
  )
}

export default ThemeConsumer(Template)

const Root = styled.div`
  background-color: ${props => props.theme.gray.a};
  padding: ${rem(56)} ${rem(layouts.defs.pad.base)};
  @media ${mq.and(tablet)} {
    padding: ${rem(60)} ${rem(layouts.defs.pad.tablet)};
  }
  @media ${mq.and(mobile)} {
    padding: ${rem(56)} ${rem(layouts.defs.pad.mobile)} ${rem(56)};
  }
`

const Head = styled(SectionHead)``

const Head_Lead = styled.div`
  @media ${mq.and(mobile)} {
    br {
      display: none;
    }
  }
`

const Container = styled.div`
  margin: 0 auto;
`

const Image = styled(GatsbyImage)`
  margin-top: ${rem(40)};
  width: 100%;
  @media ${mq.and(mobile)} {
    margin-top: ${rem(24)};
  }
`

export const query = graphql`
  query WorksSectionQuery {
    image: file(relativePath: { eq: "works.png" }) {
      childImageSharp {
        fluid(maxWidth: 1960, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp_noBase64
        }
      }
    }
  }
`
